import moment from "moment";
import { MarkedStep } from "../../../../../Models/MarkedStep";
import { AddToBasketStepState } from "../../../../../Steps/AddToBasket/Models/AddToBasketStepState";
import { PackageFromCustomerStepState } from "../../../../../Steps/PackageFromCustomer/Models/PackageFromCustomerStepState";
import { PackageToCustomerStepState } from "../../../../../Steps/PackageToCustomer/Models/PackageToCustomerStepState";
import { StepType } from "../../../../../Steps/Step/StepType";
import { Bag } from "./Bag";
import { DateTimeProvider } from "../../../../../Services/DateTimeProvider";


export enum BagName
{
    Today = "now",
    Past = "past",
    Future = "future",
    Inprogress = "inprogress",
    Other = "other",
    Rejected = "rejected",
    Insignificant = "insignificant",
    Tomorrow = "Tomorrow",
}

// TODO: dodać sortowanie po timeoucie i typie kroku
export class StepsOrganizer
{
    public Bags: Bag<MarkedStep>[] = [
        new Bag(BagName.Today, "Na dzisiaj"),
        new Bag(BagName.Past, "Zaległe"),
        new Bag(BagName.Tomorrow, "Na jutro"),
        new Bag(BagName.Future, "Na później"),
        new Bag(BagName.Inprogress, "W toku"),
        new Bag(BagName.Rejected, "Odrzucone"),
        new Bag(BagName.Insignificant, "Mało istotne"),
        new Bag(BagName.Other, "Inne"),
    ];

    public get BagsNames(): string[]
    {
        return this.Bags.map(bag => bag.Name);
    }

    public PutTo(bagName: string, item: MarkedStep)
    {
        const bag = this.Bags.find(bag => bag.Name === bagName);
        if (bag)
        {
            bag.Add(item);
        }
    }

    public PutToBag(step: MarkedStep)
    {
        const timeout = moment(step.Step.Timeout);

        if (!step.Step.HasTimeout)
        {
            this.PutTo(BagName.Other, step);
            return;
        }

        const tillTimeout = step.Step.HoursToTimeout;
        const afterTimeout = step.Step.HoursAfterTimeout;

        if ((step.Step.Type === StepType.Usage)
            || (step.Step.Type === StepType.PackageToCustomer && step.Step.Data.State.Is(PackageToCustomerStepState.InTransit))
            || (step.Step.Type === StepType.PackageFromCustomer && step.Step.Data.State.Is(PackageFromCustomerStepState.OnTheWay)))
        {
            this.PutTo(BagName.Inprogress, step);
        }
        else if (timeout.isSame(DateTimeProvider.Now, "date"))
        {
            this.PutTo(BagName.Today, step);
        }
        else if (timeout.isSame(moment(DateTimeProvider.Now).add(1, "day"), "date"))
        {
            this.PutTo(BagName.Tomorrow, step);
        }
        else if (afterTimeout && afterTimeout > 7 * 24)
        {
            this.PutTo(BagName.Past, step);
        }
        else if (step.Step.Data.State.Is(AddToBasketStepState.Rejected))
        {
            this.PutTo(BagName.Rejected, step);
        }
        else if (step.Step.Type === StepType.AddToBasket)
        {
            this.PutTo(BagName.Today, step);
        }
        else if (tillTimeout === undefined)
        {
            this.PutTo(BagName.Insignificant, step);
        }
        else if (tillTimeout < 0)
        {
            this.PutTo(BagName.Past, step);
        }
        // else if (tillTimeout >= 12)
        else if (timeout.isAfter(moment(DateTimeProvider.Now).add(1, "day"), "date"))
        {
            this.PutTo(BagName.Future, step);
        }
        else this.PutTo(BagName.Other, step);
    }
}
